/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16986c082688a4f5b3b764388c8e3ca8>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "TextNormal".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-normal
 * Usage guidance:
 * Reserved for representing Paragraph text style / Normal text style.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const TextNormalIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "TextNormalIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 1v1.5H8.751V15h-1.5V2.5H2.5V1z"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
TextNormalIcon.displayName = 'TextNormalIcon';
var _default = exports.default = TextNormalIcon;